import React, { FormEvent }  from 'react';
import UserMenu from './UserMenu';
import ProducerMenu from './ProducerMenu';
import CompanyMenu from './CompanyMenu'
import { useAblContext } from '../../Hooks/useAblContext';
import { useHistory } from 'react-router-dom';
//Regra de negócio por tipo de usuário
//Admin - Ve todos os menus e opções;
//Banca - Apenas ver filmes;
//Produtora - Apenas adicionar filme;

const Header: React.FC = () => {
  const abl = useAblContext();
  const history = useHistory();

  const handleExit = async (e: FormEvent) => {
    e.preventDefault();
    try{
      localStorage.removeItem('@authToken')

      abl.saveToken("");
      abl.saveAuthenticated(false);
      abl.saveRoles("");

      history.replace('/login');
    } catch(err){
      abl.saveToken("");
      abl.saveAuthenticated(false);
      abl.saveRoles("");
      history.replace('/login');
      console.log('Erro! :', err)
    }

  }

  return (
    <>
    <div className="container-fluid">
      <header className="row">
        <div className="col-lg-2 text-center logo">
          <a href="<?php echo $url; ?>homeAdmin.php">
          <img src="img/logo.png" alt="" />
          </a>
        </div>
        <div className="col-lg-6 col-lg-offset-4 text-right dirTopo">
          <div className="btn-group">
            <button className="btn-sm minhaConta" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={handleExit}>
              <i className="glyphicon glyphicon-user"></i> &nbsp;&nbsp;Sair
            </button>
          </div>
        </div>
      </header>
      </div>
      <nav className="menuPrincipal navbar navbar-link">
        <div className="container-fluid">
          <div className="row">
            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1" style={{display: 'block'}}>
              <div id="cssmenu">
                <ul className="nav navbar-nav">
                  { abl.roles === "admin" ? <UserMenu /> : null}
                  <ProducerMenu/>
                  <CompanyMenu/>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </>
  )
}
export default React.memo(Header);
